import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { MouseEvent } from 'react'

// Libs
import { isLiveMallClub } from '@/constants/systemType'

// Components
import Icon from '@/assets/icons'
import ShopButton from '@/components/common/Button'
import Link from '@/components/common/Link'
import LiveMallClubButton, { TButtonProps } from '@/components/common/livemallclub/Button'
// Constants

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type MobileActionsFooterProps = {
  storeUrl?: string
  contactUsUrl?: string
  onContactUsClick?: (e: MouseEvent<HTMLDivElement>) => void
  onButtonWrapperOnClick?: () => void
  addToCartButtonProps?: {
    disabled?: boolean
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void
  }
  buyNowButtonProps?: {
    disabled?: boolean
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void
  }
}

enum ButtonType {
  LIVE_MALL_CLUB = 'liveMallClub',
  SHOP = 'shop',
}

type SharedButtonPropsType = {
  size: TButtonProps['size']
  disabled: TButtonProps['disabled']
  onClick: TButtonProps['onClick']
  className: string
}

const buttonStyles: Record<ButtonType, React.CSSProperties> = {
  [ButtonType.LIVE_MALL_CLUB]: {
    minWidth: '0',
  },
  [ButtonType.SHOP]: {
    minWidth: '0',
  },
}

const MobileActionsFooter = ({
  storeUrl,
  contactUsUrl,
  onContactUsClick,
  onButtonWrapperOnClick,
  addToCartButtonProps,
  buyNowButtonProps,
}: MobileActionsFooterProps) => {
  const { t } = useTranslation()

  const sharedAddToCartProps: SharedButtonPropsType = {
    size: 'md',
    disabled: addToCartButtonProps?.disabled,
    onClick: addToCartButtonProps?.onClick,
    className: cx('product__mobile-action__button-wrapper-button'),
  }

  const sharedBuyNowProps: SharedButtonPropsType = {
    size: 'md',
    disabled: buyNowButtonProps?.disabled,
    onClick: buyNowButtonProps?.onClick,
    className: cx('product__mobile-action__button-wrapper-button', { isLiveMallClub }),
  }

  const AddToCartButton = () => {
    if (isLiveMallClub)
      return (
        <LiveMallClubButton {...sharedAddToCartProps} theme={'secondary'} styles={buttonStyles[ButtonType.LIVE_MALL_CLUB]}>
          {t('Common_AddToCart')}
        </LiveMallClubButton>
      )

    return (
      <ShopButton {...sharedAddToCartProps} isOutline>
        {t('Common_AddToCart')}
      </ShopButton>
    )
  }

  const BuyNowButton = () => {
    if (isLiveMallClub)
      return (
        <LiveMallClubButton {...sharedBuyNowProps} theme={'major'} styles={buttonStyles[ButtonType.LIVE_MALL_CLUB]}>
          {t('Common_BuyNow')}
        </LiveMallClubButton>
      )

    return <ShopButton {...sharedBuyNowProps}>{t('Common_BuyNow')}</ShopButton>
  }

  return (
    <div className={cx('product__mobile-action', { isLiveMallClub })}>
      <div className={cx('product__mobile-action__link-wrapper', { isLiveMallClub })}>
        <Link pathname={storeUrl}>
          <div className={cx('product__mobile-action__link-wrapper-link', { isLiveMallClub })}>
            {isLiveMallClub ? (
              <div className={cx('product__mobile-action__link-wrapper-link-icon')}>
                <Icon.Product />
              </div>
            ) : (
              <Icon.Store />
            )}
            <div>{isLiveMallClub ? t('Product_Merchant_LiveMallClub') : t('Product_Merchant')}</div>
          </div>
        </Link>
        <Link url={contactUsUrl} handleClick={onContactUsClick}>
          <div className={cx('product__mobile-action__link-wrapper-link', { isLiveMallClub })}>
            {isLiveMallClub ? (
              <div className={cx('product__mobile-action__link-wrapper-link-icon')}>
                <Icon.Email_bf1424 />
              </div>
            ) : (
              <Icon.Chat />
            )}
            <div>{isLiveMallClub ? t('Product_Service_LiveMallClub') : t('Product_Service')}</div>
          </div>
        </Link>
      </div>
      <div className={cx('product__mobile-action__button-wrapper', { isLiveMallClub })} onClick={onButtonWrapperOnClick}>
        {<AddToCartButton />}
        {<BuyNowButton />}
      </div>
    </div>
  )
}

export default MobileActionsFooter
